module.exports = __webpack_public_path__ + "img/mywell_4.dc36e9fe.webp";